import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hero-no-data-card',
  templateUrl: './no-data-card.component.html',
  styleUrls: ['./no-data-card.component.scss'],
})
export class NoDataCardComponent implements OnInit {
  @Input() showFocus = false;

  constructor() {}

  ngOnInit(): void {}
}
